import React from 'react';
export function ClosingSection() {
  return <section className="relative py-24 px-4 bg-gradient-to-br from-[#E91E63] via-[#AB47BC] to-[#00BCD4] overflow-hidden" data-id="element-10">
      {/* Subtle radial glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-11">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/10 rounded-full blur-[80px]" data-id="element-12"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-13">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight drop-shadow-md" data-id="element-14">
          Transformá tu planificación y llegá a la intensificación con todo
          listo
        </h2>

        <p className="text-lg md:text-xl text-white/90 mb-12 max-w-2xl mx-auto" data-id="element-15">
          Más de 500 docentes ya tienen su MegaPack. La intensificación no
          espera. Vos tampoco deberías.
        </p>

        <a href="https://checkout.infinita-mente.online/checkouts/cn/hWN9dBQQc9h2ha4bWIEiqNW5/es-ar" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#C0FF33] hover:bg-[#B0EF23] text-[#1A1A1A] font-black text-lg md:text-xl py-5 px-10 md:px-14 rounded-2xl shadow-xl shadow-lime-400/30 transition-all duration-300 transform hover:-translate-y-1 mb-6 w-full sm:w-auto" data-id="element-16">
          ¡Quiero el MegaPack ahora! →
        </a>

        <p className="text-white/70 text-sm font-medium" data-id="element-17">
          ⏰ El precio vuelve a $39.999 muy pronto. Aprovechá ahora.
        </p>
      </div>
    </section>;
}